/**
 * Model to hold result settings
 */
export class ResultSettings {
    public disableResultEntryHours: number = null;

    public clone(): ResultSettings {
        const clone: ResultSettings = new ResultSettings();
        clone.disableResultEntryHours = this.disableResultEntryHours;

        return clone;
    }

    public serialize(): any {
        return {
            disableResultEntryHours: this.disableResultEntryHours ?
                parseInt(this.disableResultEntryHours.toString(), null) : null,
        };
    }

    public deserialize(json: any): ResultSettings {
        if (!json) {
            return this;
        }

        this.disableResultEntryHours = json.disableResultEntryHours;

        return this;
    }
}
